import React from 'react';
import { Construction } from 'lucide-react';

interface WorkInProgressProps {
  className?: string;
}

export function WorkInProgress({ className = '' }: WorkInProgressProps) {
  return (
    <div className={`bg-[#5e9bb8]/5 dark:bg-[#5e9bb8]/10 border border-[#5e9bb8]/20 dark:border-[#5e9bb8]/30 rounded-xl p-6 ${className}`}>
      <div className="flex items-start gap-4">
        <Construction className="h-6 w-6 text-[#5e9bb8] dark:text-[#5e9bb8] flex-shrink-0 animate-bounce" />
        <div>
          <h3 className="text-lg font-medium text-[#5e9bb8] dark:text-[#5e9bb8] mb-2">
            Work in Progress
          </h3>
          <p className="text-gray-600 dark:text-gray-300">
            Welcome to our Privacy Center! While a lot is already done, we're continuously working to polish and improve the experience. 
            If something doesn't look or work exactly as expected, it's likely part of an upcoming implementation. 
            Check back regularly as we add new features and refinements each day.
          </p>
        </div>
      </div>
    </div>
  );
}